import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getContractPage } from "../../redux/profile/action";
import A4SizeContact from "../Common/CustomeLabel/ReactQuill/A4SizeContact";

export default function ContractView({ type = "job_agreement" }) {
    const dispatch = useDispatch();
    const [description, setDescription] = useState("");

    useEffect(() => {
        const fetchContract = async () => {
            try {
                const res = await dispatch(getContractPage(type));
                setDescription(res?.response?.description || "");
            } catch (error) {
                console.error("Contract fetch failed", error);
            }
        };

        fetchContract();
    }, [dispatch, type]);

    return (
        <div>
            <A4SizeContact value={description} />
        </div>
    );
}
